import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { KitchenDisplay } from './KitchenDisplay'

export const Routes = () => {
  return (
    <Switch>
      <Route exact path="/">
        <KitchenDisplay />
      </Route>
    </Switch>
  )
}
